import { createContext, useState, useCallback } from 'react'
import type { ReactNode } from 'react'

interface PageHeaderState {
  title: ReactNode
  actions: ReactNode
}

interface PageHeaderValue extends PageHeaderState {
  setHeader: (title: ReactNode, actions?: ReactNode) => void
}

export const PageHeaderContext = createContext<PageHeaderValue>({
  title: '',
  actions: null,
  setHeader: () => {},
})

export function usePageHeaderProvider(): PageHeaderValue {
  const [state, setState] = useState<PageHeaderState>({ title: '', actions: null })
  const setHeader = useCallback((title: ReactNode, actions: ReactNode = null) => {
    setState({ title, actions })
  }, [])
  return { ...state, setHeader }
}
